import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/coach/_backend/messages")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="sticky top-0 z-40 flex h-16 items-center justify-end gap-4 bg-white/50 backdrop-blur-lg mb-8 border-b border-gray-200">
        <div className="grow">
          <h1 className="font-heading text-text-primary text-2xl">Messages</h1>
          <p className="text-text-secondary text-sm">
            Conversations with potential clients
          </p>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
